<template>
    <div class="column" :class="getClass">
        <div class="img-container">
            <img v-if="isMobile" @click="goToLotSinglePage(bid.lot_id)" style="width: 100%; height: auto;" :src="bid.pictures.split('#')[1] + '&w=320'">
            <img v-else="" class="main" @click="goToLotSinglePage(bid.lot_id)" :src="bid.pictures.split('#')[1] + '&w=320'">
            <div class="overlay">
                <div class="text" @click="goToLotSinglePage(bid.lot_id)">Full view</div>
            </div>
        </div>
        <img v-if="!isMobile" class="extra" @click="index = 0" :src="bid.pictures.split('#')[0] + '&w=320'">
        <img v-if="!isMobile" class="extra" @click="index = 2" :src="bid.pictures.split('#')[2] + '&w=320'">
        <vue-gallery-slideshow :images="images" :index="index" @close="index = null" :id="bid.lot_id"></vue-gallery-slideshow>
    </div>
</template>

<script>
    import VueGallerySlideshow from 'vue-gallery-slideshow'
    export default {
        props: ['bid'],
        components: {
            VueGallerySlideshow
        },
        data () {
            return {
                images: this.bid.pictures.split('#'),
                index: null
            }
        },
        computed: {
            getClass() {
                if (document.documentElement.clientWidth < 450) {
                    return 'image-container-mobile'
                } else {
                    return 'image-container-desktop'
                }
            },
            isMobile() {
                return document.documentElement.clientWidth < 450;
            }
        },
        methods: {
            goToLotSinglePage(id) {
                let routeData = this.$router.resolve({
                    path: '/single/' + id,
                })

                window.open(routeData.href, '_blank');
            }
        }
    }
</script>

<style scoped>
    img {
        display:inline-block !important;
        float: left;
    }
    .main {
        height: 90px;
        width: auto;
    }
    .extra {
        padding-left: 5px;
        padding-bottom: 5px;
        height: 32px;
        width: 32px;
    }
    .image-container-desktop {
        max-height: 100px;
        max-width: 170px;
        padding-right: 0px;
    }
    .image-container-mobile {
        height: 260px;
        margin-bottom: 15px;
    }

    .overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 90px;
        width: 120px;
        opacity: 0;
        transition: .5s ease;
        background-color: rgba(0, 140, 186, 0.3);
    }
    .img-container {
        position: relative;
        width: 100%;
    }

    .img-container:hover .overlay {
        opacity: 1;
        z-index: 2000;
    }

    .text {
        color: white;
        font-size: 20px;
        position: absolute;
        top: 50px;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        text-align: center;
    }
    .text:hover {
        cursor: pointer;
    }
</style>





// WEBPACK FOOTER //
// src/components/Card/Gallery/Gallery.vue